import ApiService from '@/service/api.service.js'
import { useSWR } from '@attensi/swr'
import type { User } from './v1Responses'
import { wrapV1ApiService } from './wrapV1ApiService'

export const useMe = () => {
  return useSWR(['current-user'], fetchCurrentUser)
}

const fetchCurrentUser = () => {
  return wrapV1ApiService<User>(() => ApiService.getCurrentUser())
}
